import { base64UrlDecode } from '../base64UrlDecode';
import { bufferToHex } from '../bufferToHex';
import { compressRawPublicKey } from '../compressRawPublicKey';

export const p256Keygen = async () => {
  // Create a new P-256 keypair
  const p256Keypair = await crypto.subtle.generateKey(
    {
      name: 'ECDSA',
      namedCurve: 'P-256',
    },
    true,
    ['sign', 'verify']
  );

  // Export the raw public key. By default this will export in uncompressed format
  const rawPublicKey = await crypto.subtle.exportKey(
    'raw',
    p256Keypair.publicKey
  );

  // We need to export with JWK format because exporting EC private keys with "raw" isn't supported
  const privateKeyJwk = await crypto.subtle.exportKey(
    'jwk',
    p256Keypair.privateKey
  );

  const compressedPublicKeyBuffer = compressRawPublicKey(rawPublicKey);

  const privateKeyBuffer = base64UrlDecode(privateKeyJwk.d);

  return {
    private: bufferToHex(privateKeyBuffer),
    privateJwk: privateKeyJwk,
    public: bufferToHex(compressedPublicKeyBuffer),
  };
};
